export const HEADER_TITLE = {
  normal: 'Te pagamos hasta S/ 1000',
  lowerPrice: 'Te pagamos hasta S/ 700',
  taxi: '¿Sufriste un choque? Te pagamos en efectivo',
  launch: 'Te pagamos hasta S/ 700 por choque',
};
